<template>
  <el-dialog class="rt-lookup-dialog" size="tiny" :close-on-click-modal="false" title="查找" :visible.sync="dialogVisible" :modal="isMaskShow" :modal-append-to-body="!isMaskShow" :class="!isMaskShow?'el-dialog--diy':''">
    <div>
      <el-form label-position="left" @submit.native.prevent>
        <el-form-item label="搜索">
          <el-input v-model="filterValue" placeholder="搜索记录" @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="search" @click="handleSearch"></el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <el-table ref="lookupTable" :height="isMaskShow?450:235" style="width: 100%" highlight-current-row v-bind:data="tableData" stripe @current-change="handleCurrentChange" @row-dblclick="handleConfirm" @sort-change="handleSortChange" v-loading="loading">
      <el-table-column width="55">
        <template slot-scope="scope">
          <i class="el-icon-check" v-if="scope.row == currentRow"></i>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" v-for="display in displayFields" v-bind:key="display.name" :prop="display.name" :label="display.label" :width="display.width">
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleIndexChange" :current-page="pageIndex" :page-size="pageSize" :page-sizes="pageSizes" :layout="layout" :total="totalRecordCount">
    </el-pagination>
    <span slot="footer" class="dialog-footer" style="">
      <el-button @click="handleReset">移除值</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>



<script>
export default {
  name: "RtLookupDialog",
  props: {
    isMaskShow:{
      type:Boolean,
      required:false
    },
    entity: {
      type: String,
      required: true
    },
    requestUrl: {
      type: String,
      default: function() {
        return "../api/CrmLookupView/GetData";
      }
    },
    nameField: {
      type: String,
      default: function() {
        return "new_name";
      }
    },
    idField: {
      type: String,
      default: function() {
        return this.entity + "id";
      }
    },
    displayFields: {
      type: Array,
      default: function() {
        return [
          { name: "new_name", label: "名称" },
          { name: "createdon", label: "创建日期", width: 180 }
        ];
      }
    },
    condition: {
      type: String,
      default: function() {
        return "";
      }
    },
    orderbyFields: {
      type: String,
      default: function() {
        return "createdon desc";
      }
    },
    filterFields: {
      type: String,
      default: function() {
        return "new_name";
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,

      filterValue: "",

      pageIndex: 1,
      pageSize: 20,
      layout: "total, sizes, prev, pager, next",
      pageSizes: [10, 20, 30, 40, 50],
      totalRecordCount: 0,

      tableData: [],
      currentRow: null
    };
  },
  computed: {
    dialogTitle() {
      return "查找";
    },
    selectString: {
      get() {
        //将idField、nameField、displayFields合并，并去掉重复的字段
        var selectFields = [];
        selectFields.push(this.nameField);
        selectFields.push(this.idField);
        for (var i in this.displayFields) {
          var fieldName = this.displayFields[i].name;
          if (selectFields.indexOf(fieldName) >= 0) {
            continue;
          }
          selectFields.push(fieldName);
        }

        return selectFields.join(",");
      }
    },
    orderbyString: {
      get() {
        return this.orderbyFields;
      }
    },
    filterString: {
      get() {
        return this.filterFields;
      }
    }
  },
  mounted() {
  },
  watch:{
    condition(e){
      if(e.split(" eq ")[1]==" "){
        this.handleConfirm();
      }
    }
  },
  methods: {
    show() {
      this.dialogVisible = true;

      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleSearch() {
      this.pageIndex = 1;
      this._fetchRecords();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    handleSortChange() {
      alert("未实现");
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;

      this._fetchRecords();
    },
    handleIndexChange(pageIndex) {
      this.pageIndex = pageIndex;

      this._fetchRecords();
    },
    handleReset() {
      this.$emit("data-selected", {
        id: null,
        logicalName: this.logicalName,
        name: null
      });

      this.dialogVisible = false;
    },
    handleConfirm() {
      if(this.tableData.length>0){
      var selectedRow = this.$refs.lookupTable.store.states.currentRow;
      console.log(selectedRow);
      if (rt.isNull(selectedRow)) {
        rt.showErrorToast("请选择一条记录");
        return;
      }
      if(selectedRow.isfinish=="1"&&rt.getParameterValue("IsUnfinishedProductShippable")!="true"/*||selectedRow.isfinish=="2"*/)
      {
        rt.showErrorToast("未完工物料不可出货");
        return;
      }
      this.$emit("data-selected", {
        id: selectedRow[this.idField],
        name: selectedRow[this.nameField]
      });
      }else{
        this.$emit("data-selected", {
        id: " ",
        name: " "
      });
      }

      this.dialogVisible = false;
    },
    //数据加载
    _fetchRecords() {
      this.loading = true;
      var requestStr =
        this.requestUrl +
        "?entityName=" +
        this.entity +
        "&page=" +
        this.pageIndex +
        "&count=" +
        this.pageSize +
        "&select=" +
        this.selectString +
        "&orderby=" +
        this.orderbyString +
        "&condition=" +
        this.condition +
        "&filter=" +
        this.filterString +
        "&filterValue=" +
        encodeURIComponent(this.filterValue || "");

      rt
        .get(requestStr)
        .then(res => {
          this.tableData = res.Data;
        if(this.tableData.length<1){
            this.$emit("data-selected", {
            id: " ",
            name: " "})
          }
          this.totalRecordCount = res.TotalRecordCount;
        })
        .catch(error => {
          rt.showErrorToast(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.el-dialog--diy .el-dialog{
  width:100% !important;
  top: 0% !important;
  margin-bottom: 0px !important;
}
.rt-lookup-dialog .el-form-item .el-form-item__label {
  width: 120px;
}

.rt-lookup-dialog .el-form-item .el-form-item__label:before {
  display: none;
}

.rt-lookup-dialog .el-form-item .el-form-item__content {
  margin-left: 120px !important;
}

.rt-lookup-dialog .el-table {
  margin-top: 15px;
}

.rt-lookup-dialog .el-dialog__body {
  padding-bottom: 15px;
}

.rt-lookup-dialog .el-dialog__footer {
  padding-top: 0;
}
.rt-lookup-dialog .el-dialog--tiny{
  width: 37%;
}
</style>




// WEBPACK FOOTER //
// lookup-dialog.vue?78a8f9c9